interface IPropsConcentracaoCard {
  top5: number;
  top10: number;
  top20: number;
  hhi: number;
}

const formatPercent = (val: number | undefined | null) =>
  `${(Number(val) || 0).toFixed(2).replace('.', ',')}%`;

export const Concentracao = ({
  top5,
  top10,
  top20,
  hhi,
}: IPropsConcentracaoCard) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
      <strong
        style={{
          fontSize: '2rem',
          lineHeight: 1.1,
          color: '#111827',
          fontWeight: 700,
        }}
      >
        {formatPercent(top10)}
      </strong>
      <span style={{ fontSize: '12px', color: '#9CA3AF' }}>
        Top 10 posições
      </span>

      <div
        style={{
          display: 'flex',
          gap: '1rem',
          flexWrap: 'wrap',
          marginTop: '.25rem',
        }}
      >
        <div>
          <span style={{ fontSize: '11px', color: '#9CA3AF', display: 'block' }}>
            Top 5
          </span>
          <strong style={{ fontSize: '.9rem', color: '#111827' }}>
            {formatPercent(top5)}
          </strong>
        </div>
        <div>
          <span style={{ fontSize: '11px', color: '#9CA3AF', display: 'block' }}>
            Top 20
          </span>
          <strong style={{ fontSize: '.9rem', color: '#111827' }}>
            {formatPercent(top20)}
          </strong>
        </div>
        <div>
          <span style={{ fontSize: '11px', color: '#9CA3AF', display: 'block' }}>
            HHI
          </span>
          <strong style={{ fontSize: '.9rem', color: '#111827' }}>
            {(Number(hhi) || 0).toFixed(1).replace('.', ',')}
          </strong>
        </div>
      </div>
    </div>
  );
};
